export default __webpack_public_path__ + "static/media/tools.77e88e31.png";